module.exports = __webpack_public_path__ + "static/media/key-isolated.5acf60e8.png";